const apiUrl = process.env.REACT_APP_API_URL;
export const GetUsuaris = async ( ) => {
    try {
        const response = await fetch(`${apiUrl}:8061/usuaris?grup=`);
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
